import { create } from "zustand";

/**
 * Counts the games she has learned from this session. Her header mark turns
 * once per bump (spec §5); nothing else reads it.
 */
export const useAriadneLearned = create<{ count: number; bump: () => void }>(
  (set) => ({
    count: 0,
    bump: () => set((s) => ({ count: s.count + 1 })),
  }),
);
